import { useState, useEffect } from 'react';
import {AuthFetchAtu, AuthFetch, Fetch } from '../services/api';
import { notify } from '../utils/utils';


export const useEmpresas = () => {
    const [ empresas, setEmpresas ] = useState([]);
    const [ rutas, setRutas ] = useState([]);
    const [ unidades, setUnidades ] = useState([]); 

    useEffect(()=>{
        listarEmpresas()
    },[])

    const listarEmpresas = async () => {
        const response = await AuthFetch('/Qr/companies')
        if (response.isValid) {
            setEmpresas(response.content)
        }
    }
    
    const listarRutas = async (codEmpresa) => {
        if (!codEmpresa){
            return;
        }

        const response = await AuthFetch(`/Qr/routes?` + new URLSearchParams({
            codEmpresa: codEmpresa
        })) 

        if (response.isValid){
            setRutas(response.content)
        }
    }

    const listarUnidades = async (codEmpresa,codRuta) => {

        // if(!codEmpresa) {
        //     return;
        // }


        // const response = await AuthFetch('/Qr/unitsCompany?' + new URLSearchParams({
        //     codEmpresa: codEmpresa,
        //     codRuta: codRuta
        // }))
        
        // if(response.isValid){
        //     setUnidades(response.content)
        // }else{
        //     notify("no se pudo listar las unidades", "error")
        //     setUnidades([])
        // }
    }

    
    return {
        empresas,
        rutas,
        unidades,
        listarEmpresas,
        listarRutas,
        listarUnidades
    }
}

